export default "__VITE_ASSET__OBxVn$DX__"